import React from 'react';
import styled from 'styled-components';
import { FaCoffee } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Image from '../../parts/Image';
import Tag from '../../parts/Tag';
import Text from '../../parts/Text';
import Divider from '../../parts/Divider';
import { Link } from 'react-router-dom';
import {
  GetAdministratorDraftShop200ResponseApprovalStatusEnum,
  GetAdministratorDraftShops200ResponseInner
} from '../../../../api/v1';
import cafectSampleImage from '../../../assets/images/cafect_sample.webp';
import Button from "../../parts/Button";

type ShopListComponentProps = {
  shops: Array<GetAdministratorDraftShops200ResponseInner>
}

const ShopCardsStyle = styled(Link)`
  display: flex;
  border-top: 1px solid #dbdbdb;
  text-decoration: none;
  padding: 30px;

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 12px;
  }

  &:hover {
    background-color: #eeeeee;
    transition: background-color 0.3s ease-in-out
  }
`;

const ShopCardColumnLeft = styled.div`
  margin-right: 20px;

  @media (max-width: 767px) {
    display: none;
  }
`;

const ShopCardColumnCenter = styled.div`
  margin-right: 20px;

  @media (max-width: 767px) {
    margin: 0;
  }

  img {
    @media (max-width: 767px) {
      width: 100%;
    }
  }
`;

const ShopCardColumnRight = styled.div`
  width: 100%;
`;

const EditShopButtonStyle = styled(Button)<{liked: boolean}>`
  display: flex;
  align-items: center;
  background: #393432;
  justify-content: center;
  margin-bottom: 15px;

  svg {
    font-size: 20px;
  }

  &:hover {
    background: #696767;
  }
`;

const ShopCardColumnRightHeading = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ShopButtons = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    column-gap: 8px;

    button {
      margin-bottom: 0;
      width: 38px;
      height: 38px;

      svg {
        font-size: 14px;
      }
    }
  }
`;

const ShopInformation = styled.div`

`;

const AdministratorDraftShopList: React.FC<ShopListComponentProps> = ({ shops }) => {
  const navigate = useNavigate();
  const timeframe = {
    morning: 'モーニング',
    lunch: 'ランチ',
    dinner: 'ディナー'
  };

  const onClickEditShop = (event, shopId: number) => {
    event.preventDefault();
    navigate(`/shops/${shopId}`);
  };

  const PageTitle = ({ shopName, approvalStatus }: { shopName: string, approvalStatus: GetAdministratorDraftShop200ResponseApprovalStatusEnum }) => {
    switch (approvalStatus) {
      case GetAdministratorDraftShop200ResponseApprovalStatusEnum.Approved:
        return <Text size='24px' weight='bold' mb='5px'>承認済み：{shopName}</Text>;
      case GetAdministratorDraftShop200ResponseApprovalStatusEnum.Rejected:
        return <Text size='24px' weight='bold' mb='5px'>却下：{shopName}</Text>;
      default:
        return <Text size='24px' weight='bold' mb='5px'>未承認：{shopName}</Text>;
    }
  };

  return (
    <>
      { shops.map(shop => {
        return (
          <ShopCardsStyle key={shop.id} to={`/administrator/draft-shops/${shop.id}`}>
            <ShopCardColumnLeft>
              <EditShopButtonStyle liked={true} onClick={event => onClickEditShop(event, Number(shop.shopId))}>
                <FaCoffee />
              </EditShopButtonStyle>
            </ShopCardColumnLeft>
            <ShopCardColumnCenter>
              <Image src={shop.images[0] ? shop.images[0]?.url : cafectSampleImage} width='300px' height='170px' />
            </ShopCardColumnCenter>
            <ShopCardColumnRight>
              <ShopCardColumnRightHeading>
                <PageTitle shopName={shop.name} approvalStatus={shop.approvalStatus} />
                <ShopButtons>
                  <EditShopButtonStyle liked={true} onClick={event => onClickEditShop(event, Number(shop.shopId))}>
                    <FaCoffee />
                  </EditShopButtonStyle>
                </ShopButtons>
              </ShopCardColumnRightHeading>
              <Text size='14px' mb='10px'>{shop.description}</Text>
              <ShopInformation>
                { shop.official && <Tag mr='5px'>公式</Tag> }
                { shop.nearestStation && <Tag mr='5px'>{ shop.nearestStation }</Tag> }
                { shop.features.map(feature=> feature.name).includes('モーニング') && <Tag mr='5px'>モーニング</Tag> }
                { shop.features.map(feature=> feature.name).includes('ランチ') && <Tag mr='5px'>ランチ</Tag> }
                { shop.features.map(feature=> feature.name).includes('ディナー') && <Tag>ディナー</Tag> }
                <Divider mt='5px' mb='5px' />
                <Text size='12px'>住所：{shop.address}</Text>
                <Text size='12px'>TEL：{shop.tel}</Text>
                <Text size='12px'><b>申請者：{shop.user.username}</b></Text>
              </ShopInformation>
            </ShopCardColumnRight>
          </ShopCardsStyle>
        );
      })}
    </>
  );
};

export default AdministratorDraftShopList;
